import initializeSignatureContent from '../actions/initializeSignatureContent';
import SignatureOptionState from '../store/schema/SignatureOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import SignatureEditor from './SignatureEditor';
import toggleSignatureSetting from '../actions/toggleSignatureSetting';

export interface SignatureFullProps {
    optionStore?: SignatureOptionState;
    userOptions?: UserOptionsType;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class SignatureFull extends React.Component<SignatureFullProps, {}> {
    componentDidMount() {
        initializeSignatureContent();
    }

    render() {
        let { optionStore, userOptions } = this.props;

        return (
            <div>
                <OptionDescription>{strings.options_signature_title}</OptionDescription>
                <SignatureEditor />
                <OptionsCheckbox
                    label={strings.options_signature_signNewMails}
                    checked={getFallbackValueIfNull(
                        optionStore.signNewMails,
                        userOptions.AutoAddSignature
                    )}
                    onChange={this.onSignNewEmailsClicked}
                />
                <OptionsCheckbox
                    label={strings.options_signature_signReplies}
                    checked={getFallbackValueIfNull(
                        optionStore.signReplies,
                        userOptions.AutoAddSignatureOnReply
                    )}
                    onChange={this.onSignRepliesClicked}
                />
            </div>
        );
    }

    private onSignNewEmailsClicked(
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) {
        toggleSignatureSetting('signNewMails', checked);
    }

    private onSignRepliesClicked(
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) {
        toggleSignatureSetting('signReplies', checked);
    }
}
